import { gql } from "@apollo/client";

export const EMAIL_EXTEND_EXPIRY = gql`
  mutation emailExtendExpiry($id: Int!, $hours: Int!) {
    emailExtendExpiry(id: $id, hours: $hours) {
      id
      message
      isError
    }
  }
`;
